export interface BookingWithDocuments {
  id?: string;
  property_address: string;
  status: BookingWithDocumentsStatus;
  documents: BookingDocument[];
}

export interface BookingDocument {
  id: string;
  type: string;
  key: string;
  created_at: Date;
}

export enum BookingWithDocumentsStatus {
  Active = 'active',
  Inactive = 'inactive',
}
